import {Layout} from "antd";
import styled from "styled-components";

export const LayoutHeader = styled(Layout.Header)`
  padding: 0;
  font-weight: bold;
  color: rgb(75, 85, 94);
  height: 50px;
  line-height: 50px;
`

export const LayoutContent = styled(Layout.Content)`
  background: #0e0e0e;
  padding-bottom: 15px;
`
const FormItem = styled.div`
  & + & {
    margin-top: 24px;
  }
  span {
    margin-right: 10px;
  }
`

export const Administrator = ({data}) => {
    return (
        <Layout>
            <LayoutHeader>Administrator</LayoutHeader>
            <LayoutContent>
                <FormItem>
                    <span>Name:</span>{data?.name}
                </FormItem>
                <FormItem>
                    <span>Email:</span>{data?.email}
                </FormItem>
            </LayoutContent>
        </Layout>
    )
}